module.exports = __webpack_public_path__ + "index.html";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=index.html!./browser/index.html
 ** module id = 300
 ** module chunks = 1
 **/